import { apiRequest } from "@/utils/api";
import { API_ENDPOINTS } from "@/config/api";
import { Team } from "@/types";

export interface GeneralUserData {
  teams: Team[];
}

export async function getGeneralUserData(): Promise<GeneralUserData> {
  return apiRequest<GeneralUserData>(API_ENDPOINTS.general.userData);
}
